import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import Swal from "sweetalert2";
import PageLoading from "../../../components/Loading/PageLoading";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { useLoading } from "../../../context/LodingContext";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import {
  deletetodayproduct,
  exportPastDateProducts,
  exportTodayProduct,
  filderDateWise,
  pastDateProducts,
  todayDateProducts,
  todayProductFilterState,
  TodayProductFilterStateStateMange,
  updatetodayproduct,
  uploadTodayProduct,
} from "./todayProductData";
import BASEURL from "../../../pages/Utils/Baseurl";
import request from "graphql-request";
import { useMutation } from "@apollo/client";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { downloadExcelFile } from "../../function/downloadExcel";
import URL from "../../../pages/Utils/url";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import RoleAccess from "../../function/RoleAccess";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import TableComponents from "../../../../src/components/tabel/index";
import * as XLSX from "xlsx";
const TodayProduct = () => {
  const [todayProductFilter, dispatch] = useReducer(
    TodayProductFilterStateStateMange,
    todayProductFilterState
  );
  const [data, setData] = useState([]);
  const [fromDateError, setFromDateError] = useState(null);
  const [toDateError, setToDateError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadfile, setUploadfile] = useState("");
  const [UpdateFile] = useMutation(uploadTodayProduct);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [value, setValue] = React.useState(0);
  const { userId } = useAuthData();
  const [UpdateBrand] = useMutation(updatetodayproduct);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const [searchValue, setSearchValue] = useState("");
  const handleChange = (event, newValue) => {
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setDataCount({
      pageCount: 0,
      itemCount: 0,
    });
    setData([]);
    setValue(newValue);
    resetFilters();
  };
  useEffect(() => {
    if (value === 0 || value === 2) {
      fetchtodaydata();
    } else if (value === 1) {
      if (fromDateError || toDateError) return;
      fetchPastData();
    }
  }, [value, todayProductFilter, pagination, searchValue]);

  useEffect(() => {
    const validateDates = (fromDate, toDate) => {
      const today = new Date();
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);

      const errors = {
        fromDateError: null,
        toDateError: null,
      };

      if (fromDateObj > today) {
        errors.fromDateError = "From Date cannot be greater than today's date.";
      }

      if (toDateObj > today) {
        errors.toDateError = "To Date cannot be greater than today's date.";
      }

      if (toDateObj < fromDateObj) {
        errors.toDateError = "To Date cannot be earlier than From Date.";
      }

      return errors;
    };

    if (todayProductFilter?.fromDate || todayProductFilter?.toDate) {
      const { fromDateError, toDateError } = validateDates(
        todayProductFilter.fromDate,
        todayProductFilter.toDate
      );

      setFromDateError(fromDateError);
      setToDateError(toDateError);
    } else {
      setFromDateError(null);
      setToDateError(null);
    }
  }, [todayProductFilter?.fromDate, todayProductFilter?.toDate]);

  const todatProductListTable = {
    columns: [
      {
        header: "Product Code",
        accessorKey: "productCode",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Product Name",
        accessorKey: "productName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Product Category",
        accessorKey: "productCategory",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Product Brand",
        accessorKey: "productBrand",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Create By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Create Date",
        accessorKey: "createdAt",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      productCode: v?.productCode,
      productName: _.capitalize(v?.productName),
      productCategory: _.capitalize(v?.productCategory),
      productBrand: _.capitalize(v?.productBrand),
      createdBy: v?.user?.employeeName,
      createdAt: v?.createdAt?.slice(0, 10),

      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Today Product Screen"
            component="ViewTodayProduct"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/todays-products/view-today-product`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>
          {value != 1 && (
            <RoleAccess
              modelName="Today Product Screen"
              component="UpdateTodayProduct"
            >
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() => handleEditClick(v)}
              />
            </RoleAccess>
          )}

          <RoleAccess
            modelName="Today Product Screen"
            component="DeleteTodayProduct"
          >
            <DeleteIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDelte(v?.id)}
            />
          </RoleAccess>
        </div>
      ),
    })),
  };

  const availbleProduct = {
    columns: [
      {
        header: "Available products",
        accessorKey: "productName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Quantity",
        accessorKey: "currentStock",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      productName: _.capitalize(v?.productName),
      currentStock: _.capitalize(v?.currentStock),
    })),
  };

  const handleDownload = () => {
    setCirleLoading(true);
    if (
      todayProductFilter?.fromDate &&
      todayProductFilter?.toDate &&
      value === 1
    ) {
      const startDate = todayProductFilter?.fromDate;
      const endDate = todayProductFilter?.toDate;
      request(BASEURL, exportPastDateProducts, { startDate, endDate }).then(
        async (res) => {
          const status = res?.exportPastProduct?.success;

          const pdfurl = `${URL}${res?.exportPastProduct?.fileUrl?.slice(1)}`;

          if (status) {
            const status = await downloadExcelFile(
              pdfurl,
              "filter_Product.xlsx"
            );
            setCirleLoading(false);
          }
        }
      );
    } else {
      request(BASEURL, exportTodayProduct).then(async (res) => {
        const status = res?.exportTodayProduct?.success;
        const message = res?.exportTodayProduct?.message;

        const pdfurl = `${URL}${res?.exportTodayProduct?.fileUrl?.slice(1)}`;

        if (status) {
          const status = await downloadExcelFile(pdfurl, "Today_Product.xlsx");
          setCirleLoading(false);
        } else {
          setCirleLoading(false);
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,

            showConfirmButton: true,
          });
        }
      });
    }
  };

  const fetchtodaydata = () => {
    setIsLoading(true);
    request(BASEURL, todayDateProducts, {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      search: searchValue,
    })
      .then((res) => {
        setData([]);
        const success = res?.todayDateProducts?.success;
        const message = res?.todayDateProducts?.message;
        const totalCount = res?.todayDateProducts?.totalCount;
        const totalPages = res?.todayDateProducts?.totalPages;
        if (success) {
          const newdata = res?.todayDateProducts?.data?.map((val) => ({
            ...val,
            productImage: val?.productImage
              ? `${URL}media/${val?.productImage}`
              : null,
          }));
          setData(newdata);
          setDataCount({
            pageCount: totalPages,
            itemCount: totalCount,
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setData([]);
          setDataCount({
            pageCount: 0,
            itemCount: 0,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchPastData = () => {
    setIsLoading(true);
    request(BASEURL, pastDateProducts, {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      search: searchValue,
      startDate: todayProductFilter?.fromDate,
      endDate: todayProductFilter?.toDate,
    })
      .then((res) => {
        setData([]);
        const success = res?.pastDateProducts?.success;
        const message = res?.pastDateProducts?.message;
        const totalCount = res?.pastDateProducts?.totalCount;
        const totalPages = res?.pastDateProducts?.totalPages;
        if (success) {
          const newdata = res?.pastDateProducts?.data?.map((val) => ({
            ...val,
            productImage: val?.productImage
              ? `${URL}media/${val?.productImage}`
              : null,
          }));
          setData(newdata);
          setDataCount({
            pageCount: totalPages,
            itemCount: totalCount,
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setData([]);
          setDataCount({
            pageCount: 0,
            itemCount: 0,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
          userId: userId,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.uploadTodayProduct?.success;
      const message = response?.data?.uploadTodayProduct?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchtodaydata();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };
  const handleDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deletetodayproduct, {
            id: id,
          });

          const success = res?.deleteTodayProduct?.success;
          const message = res?.deleteTodayProduct?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              fetchtodaydata();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const resetFilters = () => {
    dispatch({ name: "reset" });
    setFromDateError(null);
    setToDateError(null);
    // if (value === 1) {
    //   fetchPastData();
    // }
  };

  const handleEditClick = (data) => {
    Swal.fire({
      title: "Edit Details",
      html: `
      <div style="display: flex; flex-direction: column; gap: 16px; text-align: left;">
        <!-- Top summary points -->
        <div style="margin-bottom: 10px; font-size: 14px; background: #f6f6f6; padding: 10px; border-radius: 8px;">
          <div><strong>Product Name:</strong> ${data?.productName || "-"}</div>
          <div><strong>Brand:</strong> ${data?.productBrand || "-"}</div>
          <div><strong>Code:</strong> ${data?.productCode || "-"}</div>
          <div><strong>Current Stock</strong> ${data?.currentStock || "-"}</div>
          <div><strong>Original Stock</strong> ${
            data?.originalStock || "-"
          }</div>
          <div><strong>stockInCtn</strong> ${data?.stockInCtn || "-"}</div>
          <div><strong>stockInPart
</strong> ${data?.stockInPart || "-"}</div>
          <div><strong>soldStock

</strong> ${data?.soldStock || 0}</div>
        </div>

        <!-- Input Fields -->
        <div style="display: flex; flex-direction: column; gap: 16px;">
          <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <label for="input1" style="font-weight: 600; margin-bottom: 6px;">ADD STOCK IN LEAST QTY</label>
            <input type="text" id="input1" class="swal2-input" style="margin: 0; width: 100%;">
          </div>
          <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <label for="input2" style="font-weight: 600; margin-bottom: 6px;">ADD STOCK IN UOM</label>
            <input type="text" id="input2" class="swal2-input" style="margin: 0; width: 100%;">
          </div>
          <div style="display: flex; flex-direction: column; align-items: flex-start;">
            <label for="input3" style="font-weight: 600; margin-bottom: 6px;">ADD STOCK IN LEAST UOM</label>
            <input type="text" id="input3" class="swal2-input" style="margin: 0; width: 100%;">
          </div>
        </div>
      </div>
    `,
      width: 500,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      preConfirm: () => {
        const input1 = document.getElementById("input1").value.trim();
        const input2 = document.getElementById("input2").value.trim();
        const input3 = document.getElementById("input3").value.trim();

        if (!input1 && !input2 && !input3) {
          Swal.showValidationMessage("Please fill at least one field.");
          return false;
        }

        return { input1, input2, input3 };
      },
    }).then(async (result) => {
      if (result.isConfirmed && result.value) {
        const { input1, input2, input3 } = result.value;
        setCirleLoading(true);

        try {
          const response = await UpdateBrand({
            variables: {
              input: {
                productId: data?.id,
                productCode: data?.productCode,
                productName: data?.productName,
                productCategory: data?.productCategory,
                productBrand: data?.productBrand,
                productBrandCode: data?.productBrandCode,
                productUom: data?.baseUom,
                baseUom: data?.productUom,
                conversion: data?.conversion,
                vat: data?.vat,
                currentStock: input1 || 0,
                stockInCtn: input2 || 0,
                stockInPart: input3 || 0,
                productImage: null,
              },
            },
            context: { hasUpload: true },
          });

          const res = response?.data?.updateTodayProduct?.success;
          const message = response?.data?.updateTodayProduct?.message;

          if (res) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            });
            fetchtodaydata();
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
            fetchtodaydata();
          }
        } catch (err) {
          console.error("Error:", err);
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const handleSampleExcelDownload = () => {
    const headers = [
      [
        "BRANDCODE",
        "CATEGORYCODE",
        "ITEMCODE",
        "ITEMNAME",
        "ITEMBRAND",
        "LEASTUOM",
        "UOM",
        "CONVERSION",
        "STOCK IN LEAST QTY",
        "CTN",
        "PCS",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(headers);
    worksheet["!cols"] = [
      { wch: 14 },
      { wch: 16 },
      { wch: 14 },
      { wch: 22 },
      { wch: 16 },
      { wch: 14 },
      { wch: 12 },
      { wch: 14 },
      { wch: 20 },
      { wch: 10 },
      { wch: 10 },
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Today_Product_Sample");
    XLSX.writeFile(workbook, "Today_Products_Sample.xlsx");

    Swal.fire({
      position: "top",
      icon: "success",
      title: "Sample Excel Downloaded Successfully",
      showConfirmButton: true,
    });
  };

  const handleUploadClick = () => {
    setUploadStatus(false); // reset first
    setTimeout(() => setUploadStatus(true), 0); // open again after reset
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {value == 0
                      ? "Today's"
                      : value == 1
                      ? "Past"
                      : "Current Stock"}{" "}
                    Products List
                  </MaterialTypography>
                </Stack>
                <RoleAccess
                  modelName="Today Product Screen"
                  component="CreateTodayProduct"
                >
                  {(value == 0 || value == 2) && (
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() =>
                        navigate("/todays-products/add-today-product", {
                          state: { type: "add" },
                        })
                      }
                    >
                      Products
                    </MaterialButton>
                  )}
                </RoleAccess>
              </Stack>
              <Box sx={{ marginTop: "5px" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#2a9941",
                          color: "white",
                        },
                      }}
                      centered
                    >
                      <Tab disabled={isLoading} label="Today Product's" />
                      <Tab disabled={isLoading} label="Past Product's" />
                      <Tab disabled={isLoading} label="Current Stock Details" />
                    </Tabs>
                  </Box>
                  {value === 1 && (
                    <Box sx={{ flex: 1 }}>
                      <Grid container spacing={2} p={1}>
                        <Grid size={{ xs: 12, sm: 5 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              From Date
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            type="date"
                            size="small"
                            name="fromDate"
                            value={todayProductFilter?.fromDate}
                            onChange={(e) =>
                              dispatch({
                                value: e?.target?.value,
                                name: "fromDate",
                              })
                            }
                          />
                          {fromDateError && (
                            <MaterialTypography
                              color="error"
                              variant="caption"
                              display="block"
                              mt={1}
                            >
                              {fromDateError}
                            </MaterialTypography>
                          )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 5 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              To Date
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            type="date"
                            size="small"
                            name="toDate"
                            value={todayProductFilter?.toDate}
                            onChange={(e) =>
                              dispatch({
                                value: e?.target?.value,
                                name: "toDate",
                              })
                            }
                          />
                          {toDateError && (
                            <MaterialTypography
                              color="error"
                              variant="caption"
                              display="block"
                              mt={1}
                            >
                              {toDateError}
                            </MaterialTypography>
                          )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2 }}>
                          <IconButton
                            onClick={resetFilters}
                            aria-label="Reset Filters"
                            color="primary"
                            sx={{ mt: 2 }}
                          >
                            <RefreshIcon fontSize="large" />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  <RoleAccess
                    modelName="Today Product Screen"
                    component="ExportTodayProduct"
                  >
                    {data?.length > 0 &&
                      (value == 0 ||
                        (value == 1 &&
                          todayProductFilter?.fromDate &&
                          todayProductFilter?.toDate)) && (
                        <button
                          className="container-btn-file"
                          onClick={handleDownload}
                          style={{
                            height: "38px",
                            marginLeft: "0",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          <svg
                            fill="#fff"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 50 50"
                          >
                            <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                          </svg>
                          Export File
                        </button>
                      )}
                  </RoleAccess>

                  {value == 0 && (
                    <button
                      className="container-btn-file"
                      style={{
                        height: "38px",
                        marginLeft: "0",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                      onClick={handleSampleExcelDownload}
                    >
                      <svg
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 50 50"
                      >
                        <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                      </svg>
                      Sample Excel
                    </button>
                  )}

                  <RoleAccess
                    modelName="Today Product Screen"
                    component="UploadTodayProduct"
                  >
                    {value == 0 && (
                      <label
                        className="container-btn-file"
                        style={{
                          height: "38px",
                          marginLeft: "0",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => handleUploadClick()} // show the modal
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 50 50"
                        >
                          <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                        </svg>
                        Upload File
                      </label>
                    )}
                  </RoleAccess>
                </Stack>
              </Box>
            </>
          }
        />

        {uploadStatus && (
          <FileUploadModal
            key={Date.now()} // force remount
            status={uploadStatus}
            onClose={() => setUploadStatus(false)}
            onSubmit={(file) => handleExcelUpload(file)}
            onDownloadSample={handleSampleExcelDownload}
          />
        )}

        <>
          <TableComponents
            rows={
              value == 2 ? availbleProduct?.rows : todatProductListTable?.rows
            }
            columns={
              value == 2
                ? availbleProduct?.columns
                : todatProductListTable?.columns
            }
            pagination={pagination}
            setPagination={setPagination}
            pageCount={dataCount.pageCount}
            recordCount={dataCount.itemCount}
            isLoading={isLoading}
            isSearch={true}
            onChange={handleSearch}
          />
        </>
      </Card>
    </DashboardLayout>
  );
};

export default TodayProduct;
